module.exports = __webpack_public_path__ + "img/symbol_0.0c3b93d4.png";